import { createSelector } from 'reselect'
import { entitySelector, resultsSelector } from 'containers/Entity/selectors'
import { getMonthDateYearTimestampString } from 'helpers/DateUtil'
import { getCSVData } from './CSVHelper'
// import { segmentSelector } from 'containers/Project/OverviewSidebar/selectors'
// import { SCHEDULE_FILTER } from 'containers/Project/ScheduleSpec/constants'

const getDateFromText = (text) => {
  return text.split('').reduce((result, value, index, array) => {
    if (index % 2 === 0 )
      result.push(array.slice(index, index + 2).join(''))
    return result
  }, []).join('/')
}

const projectScheduleEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.project_schedule_views
    ? entities.project_schedule_views
    : {}
)

const projectScheduleResultSelector = createSelector(
  resultsSelector,
  (results) => results.project_schedule_views
    ? results.project_schedule_views
    : []
)

const projectScheduleChangeSelector = state => state.project.projectSchedule.projectScheduleChange
  ? state.project.projectSchedule.projectScheduleChange
  : {}

// const projectScheduleChangeSelector = createSelector(
//   projectScheduleChangeRawSelector,
//   segmentSelector,
//   (schedules, segment) => {
//     console.log(schedules)
//     if (!segment) {
//       return schedules
//     }
//     const filter = SCHEDULE_FILTER.find(({segment: s}) => segment === s).schedules
//     Object.keys(schedules).forEach(x => {
//       if (!filter.includes(x)) {
//         delete schedules[x]
//       }
//     })
//     console.log(schedules)
//     return schedules
//   }
// )

const segmentTypeSelector = state => state.projectOverview.segment

const latestScheduleObjectSelector = createSelector(
  projectScheduleEntitySelector,
  (entity) => {
    const schedules = Object.values(entity)
    if(schedules.length > 0){
      const lastIndex = schedules.length - 1
      if(schedules[lastIndex]){
        return schedules[lastIndex]
      }
    }
    return {}
  }
)

const projectScheduleSelector = createSelector(
  latestScheduleObjectSelector,
  (latestScheduleObject) => latestScheduleObject.data ?
  latestScheduleObject.data : {}
)

const projectScheduleLastUpdatedNameSelector = createSelector(  
  latestScheduleObjectSelector,
  (latestScheduleObject) => latestScheduleObject.lastUpdateUserName ?
  latestScheduleObject.lastUpdateUserName : ''
)

const projectScheduleLastUpdatedDateSelector = createSelector(
  latestScheduleObjectSelector,
  (latestScheduleObject) => latestScheduleObject.createdAt  ?
  getMonthDateYearTimestampString(new Date(latestScheduleObject.createdAt)) : ''
)

const projectScheduleChangeValidSelector = createSelector(
  projectScheduleChangeSelector,
  (projectScheduleChange) => {
    var valid = true
    Object.values(projectScheduleChange).forEach((value) => {
      if(value.enabled && value.dateInput.length != 0 &&
        (value.dateInput.length != 6 || isNaN(Date.parse(getDateFromText(value.dateInput))))){
        valid = false
      }
    })
    return valid
  }
)

const projectScheduleParamsSelector = createSelector(
  projectScheduleChangeSelector,
  (projectScheduleChange) => {
    var params = { data: {} }
    Object.keys(projectScheduleChange).forEach((key) => {
      params.data[key] = {}
      params.data[key].enabled = projectScheduleChange[key].enabled
      params.data[key].date = projectScheduleChange[key].date
    })
    return params
  }
)

const projectScheduleCSVDataSelector = createSelector(
  projectScheduleEntitySelector,
  (entity) => {
    return getCSVData(entity)
  }
)

export {
  projectScheduleSelector,
  projectScheduleChangeSelector,
  projectScheduleLastUpdatedNameSelector,
  projectScheduleLastUpdatedDateSelector,
  projectScheduleChangeValidSelector,
  projectScheduleParamsSelector,
  projectScheduleCSVDataSelector,
  segmentTypeSelector
}